module.exports = __webpack_public_path__ + "static/NewJune-regular-853e26240df9b0e02d3b3d4438af9089.woff2";